import { z } from 'zod';
import { ALLOWED_CHARS_REGEXP, PASSWORD_MIN_LENGTH } from '@/shared/config/password';


export const credentialsSchema = z.object({
    email   : z.string().min(1, 'Email is required').pipe(z.email('Invalid email')),
    password: z.string()
        .min(PASSWORD_MIN_LENGTH, 'Password must be at least 8 characters')
        .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
        .regex(/[0-9]/, 'Password must contain at least one number')
        .regex(ALLOWED_CHARS_REGEXP, 'Password contains invalid characters'),
});

export type CredentialsFormData = z.infer<typeof credentialsSchema>;
